module.exports = __webpack_public_path__ + "img/technology-1.cf6897ac.png";